import {
  onMounted, nextTick, ref, watch, computed,
} from '@vue/composition-api'
import { pushPopup, pushHint } from '@/utils/pushPopup'

import matrixCard from '@/components/@ui/matrix-card'
import IconCard from '@/components/@ui/wrapper-matrix/components/icon'
import wrapperMatrix from '@/components/@ui/wrapper-matrix'
import authorCard from '@/components/@ui/wrapper-matrix/components/author'
import TextCard from '../TextCard'

import {
 arr, arrPopupChooseUserWrong, ICON,
} from '@/components/@ui/wrapper-matrix/users'
import {
 arrPopupWrong, arrPopupWrongAction, arrPopupActionYes, arrPopupActionNo, arrPopupWrongСalculation, arrAuthor,
} from './arr'


export default {
  name: 'matrix-2',
  components: {
    matrixCard,
    authorCard,
    TextCard,
    IconCard,
    wrapperMatrix,
  },
  props: {
    arrMatrix: {
      type: Array,
    },
    arrPopup1: {
      type: Array,
    },
    arrPopup2: {
      type: Array,
    },
    arrPopup3: {
      type: Array,
    },
    arrPopup4: {
      type: Array,
    },
    arrPopup5: {
      type: Array,
    },

    task1: {
      type: Array,
    },
    task2: {
      type: Array,
    },
    task3: {
      type: Array,
    },
    task4: {
      type: Array,
    },
    task5: {
      type: Array,
    },
  },
  setup(props, { emit }) {
    const clickIndex = ref(null)
    const proxyMatrixArr = ref(props.arrMatrix)
    const messages = ref([])
    const activateResultColInput = ref(false)
    const activateResult = ref(false)
    const selectedRow = ref(null)
    const selectedCol = ref(null)
    const stage = ref(1)
    const active = ref(false)
    const activeChooseUser = ref(false)
    const activateActionButton = ref(false)
    const maxIndex = ref(0)
    const input = ref(null)
    const lastIndex = proxyMatrixArr.value.length - 1

    const task = ref(props.task1)

    const meIndex = computed(() => proxyMatrixArr.value[lastIndex].matrix.findIndex(item => item.question))

    const init = () => {
      const my = proxyMatrixArr.value[lastIndex]
      proxyMatrixArr.value.slice(0, lastIndex).forEach((value) => {
        value.matrix = value.matrix.map((matrixValue, matrixIndex) => ({
          ...matrixValue,
          multiplyCol: matrixValue.val * my.matrix[matrixIndex].val,
        }))
      })

      proxyMatrixArr.value = proxyMatrixArr.value.map(item => ({
        ...item,
        meIndex: meIndex.value,
        multiplyRow: item.matrix.reduce((acc, value) => acc + value.multiplyCol, 0),
      }))
    }
    init()

    const handleMouseOver = (i, j) => {
      selectedRow.value = i
      selectedCol.value = j
    }

    const handleMouseOut = () => {
      selectedRow.value = null
      selectedCol.value = null
    }

    const handleMouseOverRow = (i) => {
      selectedRow.value = i
    }

    const handleMouseOutRow = () => {
      selectedRow.value = null
    }
    const isSelectedRow = (row) => {
      if (row === proxyMatrixArr.value.length - 1) {
        return false
      }
      if (row === selectedRow.value && activeChooseUser.value && !activateActionButton.value) {
        return true
      }
      return false
    }
    const handleMouseChooseUser = row => row === selectedRow.value && activeChooseUser.value

    const nextStage = () => {
      messages.value = []
      // if (stage.value === 0) {
      //   pushPopup(props.arrPopup1, messages.value)
      // }
      if (stage.value === 1) {
        active.value = true
      }
      if (stage.value === 2) {
        activateResultColInput.value = true
      }
      if (stage.value === 3) {
        activateResult.value = true
      }
      if (stage.value === 4) {
        activeChooseUser.value = true
      }
      if (stage.value === 5) {
        activateActionButton.value = true
      }
      if (stage.value === 6) {
        emit('nextStep')
      }

      stage.value += 1
    }

    const arrVal = proxyMatrixArr.value.slice(0, lastIndex).map(item => item.multiplyRow)
    const max = Math.max(...arrVal)
    const indexOfMax = (array) => {
      if (array.length === 0) {
        return -1
      }
      const maxIndexes = []
      array.forEach((item, index) => {
        if (item === max) {
          maxIndexes.push(index)
        }
      })
      return maxIndexes
    }
    maxIndex.value = indexOfMax(arrVal)


    const isSelected = (row, col) => {
      if (col === selectedCol.value && row < selectedRow.value && activateActionButton.value) {
        return true
      }
      return selectedRow.value === row && col < selectedCol.value && activateActionButton.value
    }

    const action = (answer) => {
      const me = proxyMatrixArr.value[lastIndex].matrix
      const index = me.findIndex(item => item.question)
      const countAnswer = maxIndex.value.reduce((acc, value) => {
        const v = proxyMatrixArr.value[value].matrix[index].val
         acc += v > 0 ? 1 : -1
        return acc
      }, 0)
      if (!answer && countAnswer < 0) {
        me[index].activateText = true
        me[index].answer = 0
        pushPopup(arrPopupActionNo, messages.value)
      } else if (answer && countAnswer > 0) {
        me[index].activateText = true
        me[index].answer = 1
        pushPopup(arrPopupActionYes, messages.value)
      } else {
        pushPopup(arrPopupWrongAction, messages.value)
      }
    }

    const activateButton = (matrix) => {
      if (!activateActionButton.value) return
      if (!matrix.question) return
      matrix.questionActivate = true
    }
    onMounted(() => {
      pushPopup(props.arrPopup1, messages.value)
    })
    // const findRightElem = () => proxyMatrixArr.value.slice(0, lastIndex)
    //     .filter(elem => elem.matrix.some((matrixElem, index) => {
    //       if (elem.meIndex === index) {
    //        return false
    //       }
    //        return !matrixElem.rightResultCol
    //     }))

    const concatRightArrNotQestionRow = () => {
      const filterNotQestion = proxyMatrixArr.value.map(elem => ({
        ...elem,
        matrix: elem.matrix.filter(item => !item.question),
      }))
      return filterNotQestion.reduce((acc, val) => {
        acc = [...acc, ...val.matrix]
        return acc
      }, [])
    }
    const countRightElem = countElem => countElem.reduce((acc, val) => {
        if (val.right) {
          return acc + 1
        }
        return acc
      }, 0)

    const activateInputs = (countElem) => {
      countElem.forEach((item) => {
        if (!item.right) {
          item.right = true
          item.input = item.val
          item.activateInput = true
        }
      })
    }
    const countRightElemCol = () => concatRightArrNotQestionRow().filter(item => item.rightResultCol)
    //
    const activateColInputs = () => {
      concatRightArrNotQestionRow().forEach((item) => {
          item.rightResultCol = true
          item.inputResultCol = String(item.multiplyCol)
          // item.activateInput = true
      })
    }

    watch(() => proxyMatrixArr.value, () => {
      if (stage.value === 2) {
        const concatRightElem = concatRightArrNotQestionRow()
        if (countRightElem(concatRightElem) === 10) {
          activateInputs(concatRightElem)
          pushPopup(props.arrPopup2, messages.value)
          task.value = props.task2
        }
        // if (countElem.every(({ right }) => right)) {
        //   pushPopup(props.arrPopup2, messages.value)
        //   task.value = props.task2
        // }
      } else if (stage.value === 3) {
        // const equal = findRightElem()
        if (countRightElemCol().length === 10) {
          activateColInputs()
          pushPopup(props.arrPopup3, messages.value)
          task.value = props.task3
        }
        // if (equal.length === 0) {
        //   pushPopup(props.arrPopup3, messages.value)
        //   task.value = props.task3
        // }
      } else if (stage.value === 4) {
        const equal = proxyMatrixArr.value.slice(0, lastIndex).every(elem => elem?.rightResultRow)
        if (equal) {
          pushPopup(props.arrPopup4, messages.value)
          task.value = props.task4
        }
      }
    }, { deep: true })

    const inputFocus = (matrix) => {
      nextTick(() => {
        const elem = input.value.find(item => item.$attrs.id === `item_${matrix.id}`).$el.children[0]
        elem.focus()
      })
    }

    const activateInput = (matrix) => {
      if (active.value && !matrix.question && !activateResultColInput.value) {
        proxyMatrixArr.value.forEach((item) => {
          item.matrix.forEach((m) => {
            if (m.activateInput && m.input === '') {
              m.activateInput = false
            }
          })
        })
        matrix.activateInput = true
        inputFocus(matrix)
      }
    }
    const chooseUsers = ref([])

    watch(() => chooseUsers.value, () => {
      if (maxIndex.value.length === chooseUsers.value.length) {
        if (maxIndex.value.length === 1) {
          // const find = arrMatrixRandom.find(item => item.me)
          const str1 = `Ого, у ${ proxyMatrixArr.value[maxIndex.value[0]].namePretext} и Толи похожие музыкальные интересы! Теперь осталось сказать, стоит ли рекомендовать Толе песню ${arrAuthor[meIndex.value].name}`
          const str2 = `Ого, у ${ proxyMatrixArr.value[maxIndex.value[0]].namePretext} и Толи похожие музыкальные интересы!`
          const strResult = meIndex.value === 0 ? str2 : str1
          // const str = `Ого, у ${ proxyMatrixArr.value[maxIndex.value[0]].namePretext} и у Толи похожие музыкальные интересы!
          // Теперь осталось сказать, стоит ли рекомендовать Толе песню ${arrAuthor[meIndex.value].name}.`

          task.value = [{ text: strResult }]

          pushPopup([{ text: strResult, buttonTitle: 'Продолжить' }], messages.value)
        } else {
          pushPopup(props.arrPopup5, messages.value)
          task.value = props.task5
        }
      }
    })

    const chooseUser = (indexRow) => {
      if (!activeChooseUser.value) return
      if (+indexRow === lastIndex) return
      if (maxIndex.value.length === chooseUsers.value.length) {
        return
      }
      if (maxIndex.value.indexOf(indexRow) !== -1) {
        chooseUsers.value.push(indexRow)
      } else {
        pushHint(arrPopupChooseUserWrong, messages.value)
      }
    }

    const handleInput = (event, matrix) => {
      if (matrix.input === '') return
      const reg = matrix.input.match(/[^-]/g)
      if (!reg) return

      if (reg.length === 3 && (Number(matrix.input) !== Number(matrix.val))) {
        pushHint(arrPopupWrong, messages.value)
        matrix.input = ''
      }

      if (Number(matrix.input) === Number(matrix.val) && matrix.input !== '') {
        matrix.right = true
      }
    }

    const handleInputResultCol = (event, matrix) => {
      if (matrix.inputResultCol === '') return
      const reg = matrix.inputResultCol.match(/[^-]/g)
      if (!reg) return

      if (reg.length === 3 && Number(matrix.inputResultCol) !== Number(matrix.multiplyCol)) {
        matrix.inputResultCol = ''
        pushHint(arrPopupWrongСalculation, messages.value)
      }

      if (Number(matrix.inputResultCol) === Number(matrix.multiplyCol) && matrix.inputResultCol !== '') {
        matrix.rightResultCol = true
      }
    }
    const blur = (event, matrix) => {
      if (!matrix.right) {
        matrix.input = ''
      }
    }


    const handleInputResultRow = (event, author) => {
      if (author.inputResultRow === '') return
      const reg = author.inputResultRow.match(/[^-]/g)
      if (!reg) return

      if (reg.length === 3 && Number(author.inputResultRow) !== Number(author.multiplyRow)) {
        author.inputResultRow = ''
        pushHint(arrPopupWrongСalculation, messages.value)
      }

      if (Number(author.inputResultRow) === Number(author.multiplyRow) && author.inputResultCol !== '') {
        author.rightResultRow = true
      }
    }


    return {
      selectedRow,
      selectedCol,
      clickIndex,
      proxyMatrixArr,
      arr,
      ICON,
      messages,
      activateResultColInput,
      activateResult,
      activeChooseUser,
      chooseUsers,
      activateActionButton,
      input,
      meIndex,
      task,
      blur,

      handleMouseChooseUser,
      isSelectedRow,
      chooseUser,
      handleInputResultRow,
      handleInputResultCol,
      handleInput,
      activateInput,
      nextStage,
      activateButton,
      action,
      isSelected,
      handleMouseOver,
      handleMouseOut,
      handleMouseOverRow,
      handleMouseOutRow,
    }
  },
}
